import { app_perm_template_request_line_RowClass } from "../../dbschema/app_perm_template_request_line.model";
import { BaseContainerModel } from "../base-container.model";

export class PermissionTemplateRequestLineContainerModel extends BaseContainerModel{
    app_perm_template_request_line: app_perm_template_request_line_RowClass = new app_perm_template_request_line_RowClass();
}